// Import all used JS files here for building that should be on every page. Otherwise, include them in corresponding page script

import "../third-party/jquery-import";
import "../third-party/popper";
import "../third-party/bootstrap";

import "../components/forms";
import "../components/contactModal";
import "../components/referralsModal";
import "../components/newsletterModal";
import "../components/navigationModal";

import "../components/analytics";
